import LanguageIcon from "@mui/icons-material/Language";
import { Grid } from "@mui/material";
import useTranslation from "../../../hooks/useTranslation";
import TrainingModule from "../../../models/trainingModule";
import { TouchpointCard } from "../../TouchpointCard/TouchpointCard";
import { Typography } from "../../ui/Typography/Typography";
import { IconTypes } from "../../ui/icons";
import { Icon } from "../../ui/icons/Icon";
import "./TrainingModuleContent.scss";

interface TrainingModuleContentProps {
  trainingModule: TrainingModule;
}

export const TrainingModuleContent = ({
  trainingModule,
}: TrainingModuleContentProps) => {
  const { t } = useTranslation("trainingPage");
  return (
    <div className="TrainingModuleContent">
      <Typography
        tagVariant="h1"
        desktop="h1"
        className={"TrainingModuleContent__title"}
      >
        {trainingModule.title}
      </Typography>
      <Typography
        desktop="body2"
        color="secondary"
        className="TrainingModuleContent__description"
      >
        {trainingModule.description}
      </Typography>
      <Grid container>
        <Grid item sm={12} md={6}>
          <div className="TrainingModuleContent__info">
            <Icon type={IconTypes.Audience} color="secondary" />
            <Typography desktop="body2" color="secondary">
              {t(`modules.audience.${trainingModule.audience.toLowerCase()}`)}
            </Typography>
          </div>
          <div className="TrainingModuleContent__info">
            <Icon type={IconTypes.Touchpoint} color="secondary" />
            <Typography desktop="body2" color="secondary">
              {t(`modules.touchpoints.info`, {
                count: trainingModule.touchPoints.length,
                duration: trainingModule.duration,
              })}
            </Typography>
          </div>
        </Grid>
        <Grid item sm={12} md={6}>
          <div className="TrainingModuleContent__info">
            <LanguageIcon className="TrainingModuleContent__info__icon" />
            <div className="TrainingModuleContent__info__list">
              {trainingModule.languages.map((language, index) => (
                <Typography
                  desktop="body2"
                  color="secondary"
                  className="TrainingModuleContent__info__text"
                  key={language}
                >
                  {index !== 0 && "  • "}
                  {language}
                </Typography>
              ))}
            </div>
          </div>
        </Grid>
        {trainingModule.touchPoints.map((touchpoint) => (
          <Grid item sm={12} key={touchpoint.order}>
            <TouchpointCard
              touchpoint={touchpoint}
              order={touchpoint.order}
              canAccess={trainingModule.canAccess}
              deliveryMethod={trainingModule.deliveryMethod}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
